// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { miniCartStyles } from "@guestsupply/App/Components/MiniCart/MiniCart";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { color, styledScrollbar, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

const cartLineHeaderColumn = css`
    display: flex;
    align-items: center;
    min-height: 26px;
    &:not(:first-child) {
        padding-left: 8px;
        border-left: 2px solid ${color("common.border")};
    }
`;

miniCartStyles.cartLinesWrapper = {
    css: css`
        position: relative;
        min-height: 90px;
        overflow-x: hidden;
        width: 100%;
        padding: 0 17px;
        ${styledScrollbar(4)}
    `,
};

miniCartStyles.cartLinesHeader = {
    css: css`
        display: flex;
        max-width: 100%;
        padding: 17px 0 8px;
        margin: 0 17px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

miniCartStyles.itemDescription = {
    css: css`
        ${cartLineHeaderColumn}
        width: 255px;
    `,
};

miniCartStyles.qty = {
    css: css`
        ${cartLineHeaderColumn}
        width: 68px;
    `,
};

miniCartStyles.price = {
    css: css`
        ${cartLineHeaderColumn}
        width: 115px;
    `,
};

miniCartStyles.total = {
    css: css`
        ${cartLineHeaderColumn}
        min-width: 125px;
        flex-grow: 1;
    `,
};

miniCartStyles.cartLineHeaderColumnText = {
    size: 12,
    lineHeight: "13px",
    weight: 500,
};

miniCartStyles.summarySectionWrapper = {
    css: css`
        position: sticky;
        bottom: 0;
        padding: 17px;
        border-top: 1px solid ${color("common.border")};
        background: ${color("common.ui1")};
        z-index: 2;
    `,
};

miniCartStyles.infoWrapper = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        height: 25px;
    `,
};

miniCartStyles.miniCartInfoItem = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                align-items: baseline;
                &:last-child {
                    justify-content: flex-end;
                }
            `,
        },
        heading: {
            size: 14,
            weight: 400,
            css: css`
                line-height: 21px;
            `,
        },
        text: {
            size: 20,
            weight: "bold",
            css: css`
                line-height: 26px;
            `,
        },
    }),
};

miniCartStyles.actionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    `,
};

miniCartStyles.checkoutButton = {
    sizeVariant: "medium",
    mergeCss: true,
    typographyProps: {
        lineHeight: "15px",
    },
    css: css`
        flex: 1 1 0%;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

miniCartStyles.viewCartButton = {
    sizeVariant: "medium",
    variant: "tertiary",
    mergeCss: true,
    typographyProps: {
        lineHeight: "15px",
    },
    css: css`
        flex: 1 1 0%;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

miniCartStyles.centerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        min-width: 250px;
        min-height: 200px;
        justify-content: center;
    `,
};

miniCartStyles.cantCheckoutCart = {
    css: css`
        margin: 17px 17px 0 17px;
    `,
};

miniCartStyles.notify = {
    css: css`
        margin-bottom: 0;
    `,
};

miniCartStyles.emptyCartWrapper = {
    css: css`
        padding: 17px;
    `,
};

miniCartStyles.emptyCartText = {
    as: "p",
    css: css`
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
    `,
};

miniCartStyles.fancyScrollStyle = {
    css: css`
        padding-right: 2px;
        span[direction="down"] {
            bottom: 104px;
            width: calc(100% - 7px);
        }
        span[direction="up"] {
            top: -1px;
        }
    `,
};

miniCartStyles.miniCartPager = {
    css: css`
        display: inline-block;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        padding: 17px 17px 0;
        text-align: right;
        width: 100%;
    `,
};
miniCartStyles.minCartContentWrapper = {
    css: css`
        overflow: auto;
        max-height: 500px;
        ${styledScrollbar(4)}
    `,
};
